// src/NavBar.tsx
import React from 'react';
import { Link } from 'react-router-dom';

interface NavBarProps {
  eventName: string;
  eventId: string;
}

const NavBar: React.FC<NavBarProps> = ({ eventName }) => {
  return (
    <nav aria-label="Breadcrumb" className="breadcrumb">
      <ol className="breadcrumb-list">
        <li className="breadcrumb-item">
          <Link to="/">All Events</Link>
        </li>
        <li className="breadcrumb-item breadcrumb-item--current" aria-current="page">
          {eventName}
        </li>
      </ol>
    </nav>
  );
};

export default NavBar;